export class Setpoint {
    paramId: string;
    value: number|string|boolean;

    constructor(paramId: string, value: number|string|boolean) {
        this.paramId = paramId;
        this.value = value;
    }
}
